import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

import routes from '../../routers'
import localStorage from '../../utils/localStorage'

import './style.css'

// Change this when the announcement changes, so people who closed the old one see the new one
const BANNER_VERSION = '2026-09-search-audio-comments'
// Printed cookbooks are open to this person (user.cookbook_enabled): announce the launch
const COOKBOOK_BANNER_VERSION = '2026-10-cookbooks-launch'
const DISMISSED_KEY = 'productUpdatesBannerDismissed'

const dismissedVersion = () => {
  try {
    return localStorage.getItem(DISMISSED_KEY)
  } catch (e) {
    return null
  }
}

const ProductUpdatesBanner = () => {
  const cookbooks = useSelector((state) => !!state.user?.data?.cookbook_enabled)
  const version = cookbooks ? COOKBOOK_BANNER_VERSION : BANNER_VERSION
  const [dismissed, setDismissed] = useState(dismissedVersion)

  if (dismissed === version) {
    return null
  }

  const dismiss = () => {
    try {
      localStorage.setItem(DISMISSED_KEY, version)
    } catch (e) {
      // Browser storage is blocked (e.g. private mode): hide it for this visit only
    }
    setDismissed(version)
  }

  return (
    <div className="productUpdatesBanner" role="region" aria-label="What's new in Morsel">
      <div className="productUpdatesInner">
        <p className="productUpdatesText">
          <span className="productUpdatesItem">
            <span className="productUpdatesTag">Recently launched</span>
            <strong>Recipe search · Recipe audio memories · Recipe comments</strong>
          </span>
          {cookbooks ? (
            <span className="productUpdatesItem">
              <span className="productUpdatesTag">New</span>
              <Link className="productUpdatesLink" to={routes.purchaseBook}>
                Printed family cookbooks: make yours for the holidays
              </Link>
            </span>
          ) : (
            <span className="productUpdatesItem">
              <span className="productUpdatesTag productUpdatesTagSoon">Coming soon</span>
              Printed cookbooks, and many more features
            </span>
          )}
        </p>
        <button
          type="button"
          className="productUpdatesClose"
          onClick={dismiss}
          aria-label="Close this message"
        >
          ×
        </button>
      </div>
    </div>
  )
}

export default ProductUpdatesBanner
